import { useTranslation } from 'react-i18next';

import { Button, NumberInput } from '@app/shared/ui/atoms/Common';
import { RadioGroup } from '@app/shared/ui/molecules/Admin/Common';
import {
  BALANCE_OPTIONS,
  BALANCE_PLACEHOLDERS_MAP,
  TRANSACTION_OPTIONS,
  TRANSACTION_PLACEHOLDERS_MAP,
} from '@app/shared/constants/admin/balance';
import { AdminBalanceAction } from '@app/store/slices/admin/adminTypes';
import { PriceType } from '@app/shared/types/common';

interface TransactionSectionProps {
  transactionType: AdminBalanceAction;
  onTransactionTypeChange: (value: AdminBalanceAction) => void;
  transactionAmount: number;
  onTransactionAmountChange: (value: number) => void;
  balanceType: PriceType;
  onBalanceTypeChange: (value: PriceType) => void;
  onTransactionBtnClick: () => void;
  isTransactionBtnDisabled: boolean;
}

export function TransactionSection({
  transactionType,
  onTransactionTypeChange,
  transactionAmount,
  onTransactionAmountChange,
  balanceType,
  onBalanceTypeChange,
  onTransactionBtnClick,
  isTransactionBtnDisabled,
}: TransactionSectionProps) {
  const { t } = useTranslation();

  const transactionOptions = TRANSACTION_OPTIONS.map((item) => ({
    value: item.value,
    label: t(`admin_balance.${item.translationKey}`),
  }));

  return (
    <section className="flex flex-col gap-2">
      <span className="text-sm font-medium">{t('admin_balance.transaction')}</span>
      <RadioGroup
        items={transactionOptions}
        value={transactionType}
        onValueChange={onTransactionTypeChange}
      />
      <RadioGroup items={BALANCE_OPTIONS} value={balanceType} onValueChange={onBalanceTypeChange} />
      <NumberInput
        value={transactionAmount}
        onChange={(e) => onTransactionAmountChange(Number(e.target.value))}
        placeholder={`${t('admin_balance.enter_sum')} ${BALANCE_PLACEHOLDERS_MAP[balanceType]}`}
      />
      <Button
        onClick={onTransactionBtnClick}
        disabled={isTransactionBtnDisabled}
        className="disabled:opacity-50"
      >
        {t(`admin_balance.${TRANSACTION_PLACEHOLDERS_MAP[transactionType]}`)}
      </Button>
    </section>
  );
}
